import { useTranslation } from 'react-i18next';
import { CrownIcon } from 'assets/icons';
import { events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import useAnalytics from 'services/hooks/analytics';
import { locations } from 'services/routes/locations';
import {
  StyledFreeAccountContainer,
  StyledUpgradeLink,
  StyledUpgradeText,
} from './styled';

const UpgradeBanner = () => {
  const { t } = useTranslation();
  const { track } = useAnalytics();

  const handleTrackClick = () => {
    track(
      events.upgradeSubscription(
        'upgrade_banner',
        AnalyticsEventLocation.SUBSCRIPTION_PAGE
      )
    );
  };
  return (
    <StyledFreeAccountContainer>
      <CrownIcon />
      <StyledUpgradeText>
        {t('account:subscription:upgradeAccount')}
      </StyledUpgradeText>
      <StyledUpgradeLink
        to={{ pathname: locations.subscription.pricing.pathname('') }}
        onClick={handleTrackClick}
      >
        {t('aiMusicGenerator:upgrade:action').toUpperCase()}
      </StyledUpgradeLink>
    </StyledFreeAccountContainer>
  );
};
export default UpgradeBanner;
